import {GroupsRoute} from "./routes/Groups.js";
import {GroupsSearchRoute} from "./routes/GroupsSearch.js";
const routes = [GroupsSearchRoute, GroupsRoute];
export default routes;
